<template>
  <error-view error-type="no-permissions" />
</template>

<script>
import ErrorView from '@/views/error.vue'

export default {
  components: {
    'error-view': ErrorView
  }
}
</script>

<style scoped>
.access-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

img {
  max-width: 600px;
}

.access-desc {
  max-width: 600px;
}
</style>
